<template>
  <div class="columns mx-0">
    <div class="container my-4">
      <div v-if="error" class="error  mx-6 my-6">
        <div class="notification is-danger">
          Une erreur est survenue, offre non enregistrée.
          <img src="../assets/mailunsent.svg" />
        </div>
      </div>
      <div v-if="success" class="success  mx-6 my-6">
        <div class="notification is-info">
          OK! Offre enregistrée.
          <img src="../assets/mailsent.svg" />
        </div>
      </div>
      <div
        v-if="page && !error && !success"
        class="content mx-6 my-6 has-background-light"
        id="contactbox"
      >
        <form @submit.prevent="SubmitJob" id="frm" name="frm" class="px-6 py-6">
          <h3 class="title">Soumettre une offre d'emploi</h3>
          <b-message
            >Votre offre n'apparaitra pas immédiatement, mais seulement après
            validation de notre part.<br />Retour à la
            <router-link to="/page/emploi">liste des offres</router-link
            >.</b-message
          >
          <div class="field">
            <label class="label">Titre de l'offre</label>
            <div class="control">
              <input
                id="titre"
                name="titre"
                v-model="contact_titre"
                class="input is-success"
                type="text"
                placeholder=""
                minlength="5"
                maxlength="50"
                value=""
                required
              />
            </div>
          </div>
          <div class="field">
            <label class="label">Type de contrat</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select
                  id="type_contrat"
                  name="type_contrat"
                  required
                  v-model="contact_type_contrat"
                >
                  <option value="CDI Temps plein">CDI Temps plein</option>
                  <option value="CDD Temps plein">CDD Temps plein</option>
                  <option value="CDI Temps partiel">CDI Temps partiel</option>
                  <option value="CDD Temps partiel">CDD Temps partiel</option>
                  <option value="Stage">Stage</option>
                  <option value="Autre">Autre</option>
                </select>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">Département / Ville</label>
            <div class="control">
              <input
                id="region"
                name="region"
                v-model="contact_region"
                class="input is-success"
                type="text"
                placeholder=""
                minlength="2"
                value=""
                required
              />
            </div>
          </div>

          <div class="field">
            <label class="label">Hôpital / Service</label>
            <div class="control">
              <input
                id="structure"
                name="structure"
                v-model="contact_structure"
                class="input is-success"
                type="text"
                placeholder=""
                minlength="2"
                value=""
                required
              />
            </div>
          </div>

          <div class="field">
            <label class="label">Date de prise de fonction</label>
            <div class="control">
              <input
                id="startdate"
                name="startdate"
                v-model="contact_startdate"
                class="input is-success"
                type="text"
                placeholder=""
                minlength="2"
                value=""
                required
              />
            </div>
          </div>

          <div class="field">
            <label class="label">Détail de l'offre</label>
            <p>
              Vous pouvez rédiger une offre ou bien copier/coller le texte d'un
              document Word<br />Vous ne vouvez pas joindre de fichier mais vous
              pouvez mettre un lien vers celui-ci s'il est hébergé ailleurs.
            </p>
            <div class="control">
              <vue-editor
                v-model="contact_contenu"
                :editorToolbar="customToolbar"
              ></vue-editor>
            </div>
          </div>

          <div class="field">
            <label class="label">Email de contact</label>
            <div class="control">
              <input
                id="apply_email"
                name="apply_email"
                v-model="contact_apply_email"
                class="input is-success"
                type="email"
                placeholder=""
                value=""
                required
              />
            </div>
          </div>

          <div class="field is-grouped">
            <div class="control">
              <input
                v-model="contact_hp"
                class="aria-hidden"
                type="hidden"
                value=""
                name="hp"
              />
              <button class="button is-link">Envoyer</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
const axios = require("axios");
const moment = require("moment");
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  data: function() {
    return {
      maintitle: "Soumettre une offre",
      iconPack: "fas",
      contact_titre: null,
      contact_type_contrat: null,
      contact_region: null,
      contact_structure: null,
      contact_startdate: null,
      contact_contenu: null,
      contact_apply_email: null,
      contact_hp: null,
      error: null,
      success: null,
      page: true,
      loading: true,
      at: moment().format("DD MMM, YYYY"),
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    };
  },
  name: "SubmitJob",
  props: {
    msg: String,
  },
  methods: {
    SubmitJobTest: function() {
      var vm = this;
      console.log(vm.contact_contenu);
    },
    SubmitJob: function(submitEvent) {
      var vm = this;
      var fetchurl = this.$api_url_postjob;
      // Sanitize contact_contenu before sending
      vm.contact_contenu = this.$sanitize(vm.contact_contenu);
      axios({
        method: "post",
        url: fetchurl,
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          data: {
            titre: vm.contact_titre,
            type_contrat: vm.contact_type_contrat,
            contenu: vm.contact_contenu,
            region: vm.contact_region,
            structure: vm.contact_structure,
            apply_email: vm.contact_apply_email,
            startdate: vm.contact_startdate,
          },
        }),
      })
        .then(function() {
          vm.success = true;
        })
        .catch(function() {
          vm.error = true;
        });
      submitEvent.preventDefault();
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact_form {
  margin-top: 60px;
  padding-bottom: 60px;
}

#contactbox {
  border-top: 0px solid #004c88;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

</style>
